import { NgModule } from '@angular/core';
import { BackendModule } from '@freelancer/datastore/core';
import { StoreModule } from '@ngrx/store';
import { contestHandoverDisputesBackend } from './contest-handover-disputes.backend';
import { contestHandoverDisputesReducer } from './contest-handover-disputes.reducer';

@NgModule({
  imports: [
    StoreModule.forFeature(
      'contestHandoverDisputes',
      contestHandoverDisputesReducer,
    ),
    BackendModule.forFeature(
      'contestHandoverDisputes',
      contestHandoverDisputesBackend,
    ),
  ],
})
export class DatastoreContestHandoverDisputesModule {}
